export function hasCoachReplyAfterMessage(conversation = [], userText = '') {
  const list = Array.isArray(conversation) ? conversation : [];
  const index = list.findIndex(message => message?.role === 'user' && message?.text === userText);
  return index >= 0 && list.slice(index + 1).some(message => message?.role === 'coach');
}

export function mergePendingCoachMessage(canonical = [], pending = null) {
  const list = Array.isArray(canonical) ? canonical : [];
  if (!pending?.text) return list;
  const alreadyPersisted = list.some(message => message?.role === 'user' && message?.text === pending.text);
  return alreadyPersisted ? list : [...list, pending];
}

export function shouldPreserveCoachMessageOnError(error) {
  return error?.possiblySaved === true;
}
